
import { Dropdown } from 'primereact/dropdown';

export function WisdomDropdown({placeholder, options, value, optionalLabel, optionalValue, onChange, highlightOnSelect=false, checkmark=false, width='300px'}){
    return(
        <div>
            <Dropdown 
                options={options}
                optionLabel={optionalLabel}
                optionValue={optionalValue}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                highlightOnSelect={highlightOnSelect}
                checkmark={checkmark}
                style={{width:width}}
                filter
                filterDelay={400}
            />
        </div>
    )
}

export default WisdomDropdown;